// Importaciones necesarias...
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";
import { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useParams } from "react-router-dom";
import ObtenerEquiposInstalados from "./ObtenerEquiposInstalados";
import Header from "components/Headers/Header";
import { FcSupport } from "react-icons/fc";
import ReactModal from "react-modal";

const AsignaEquiposEdicion = (props) => {
  const [selectedOptions2, setSelectedOptions2] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [options2, setOptions2] = useState([]);
  const [postSerial, setPostSerial] = useState("");
  const [postCapacidad, setPostCapacidad] = useState(null);
  const [postFechaFabricacion, setPostFechaFabricacion] = useState(null);
  const [postPrueba, setPostPrueba] = useState(null);
  const [postUltimaPrueba, setPostUltimaPrueba] = useState(null);
  const [postInstalacion, setPostInstalacion] = useState("");
  const [postTipoEquipo, setPostTipoEquipo] = useState("");
  const [options, setOptions] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerTipoEquipos",
    })
      .then((response) => {
        const apiOptions = response.data.map((item) => ({
          value: item.id,
          label: item.nombre,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => {
        console.log("Error al obtener los tipos de equipo:", error);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (selectedOptions) {
      setLoading(true);
      axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: `https://inspecciongnvback.azurewebsites.net/api/v1/EquiposPorTipo/${selectedOptions.value}`,
      })
        .then((Response) => {
          const apiOptions = Response.data.map((item) => ({
            value: item.id,
            label: item.nombre,
            tipo: item.tipo,
          }));
          setOptions2(apiOptions);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => setLoading(false));
    }
  }, [selectedOptions]);

  const postData = (e) => {
    e.preventDefault();

    if (postTipoEquipo === 1) {
      if (
        !selectedOptions2.value ||
        !postSerial ||
        !postCapacidad ||
        !postInstalacion
      ) {
        alert("Faltan campos obligatorios para la información del cilindro");
        return;
      }
    } else if (postTipoEquipo === 2) {
      if (!selectedOptions2.value || !postSerial) {
        alert("Faltan campos obligatorios para el regulador");
        return;
      }
    }

    setLoading(true);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback.azurewebsites.net/api/v1/CreaEquipoInstalado",
      data: {
        ordenId: props.idOrden,
        equipoId: selectedOptions2.value,
        NombreEquipo: selectedOptions2.label,
        serial: postSerial,
        capacidad: postCapacidad,
        fechaFabricacion: postFechaFabricacion,
        prueba: postPrueba,
        ultimaPrueba: postUltimaPrueba,
        fechaInstalacion: postTipoEquipo === 1 ? postInstalacion : null,
        tipoEquipo: postTipoEquipo,
      },
    })
      .then((Response) => {
        alert("Equipo creado con éxito!");
        setSelectedOptions2([]);
        setPostSerial("");
        setPostCapacidad(null);
        setPostFechaFabricacion(null);
        setPostPrueba(null);
        setPostUltimaPrueba(null);
        setPostInstalacion("");
        setPostTipoEquipo("");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      })
      .finally(() => setLoading(false));
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-yellow btn-lg"
        onClick={handleOpenModalTest}
        title="Agregar Equipos"
        style={{ border: "2px solid #0085CA" }}
      >
        <FcSupport style={{ marginRight: "0px" }} />
      </button>
      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal}>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <Col xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <h3 className="mb-0">Asignación de Equipos</h3>
                </CardHeader>
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Información del Equipo a Instalar
                    </h6>
                    {loading && (
                      <p style={{ color: "blue" }}>
                        <b>Cargando información...</b>
                      </p>
                    )}
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label className="form-control-label">
                              Tipo Equipo
                            </label>
                            <Select
                              options={options}
                              classNamePrefix="select"
                              onChange={(selected) => {
                                setSelectedOptions(selected);
                                setSelectedOptions2([]);
                                setPostTipoEquipo(selected.value);
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label className="form-control-label">Marca</label>
                            <Select
                              options={options2}
                              classNamePrefix="select"
                              onChange={(selected) => {
                                setSelectedOptions2(selected);
                                setPostTipoEquipo(selected.tipo);
                              }}
                              value={selectedOptions2}
                              isDisabled={loading}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label className="form-control-label">Serial</label>
                            <Input
                              placeholder="# de serial"
                              onChange={(e) => setPostSerial(e.target.value)}
                              value={postSerial}
                              disabled={loading}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>

                    {postTipoEquipo === 1 && (
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label>Capacidad</label>
                              <Input
                                placeholder="Capacidad"
                                onChange={(e) =>
                                  setPostCapacidad(e.target.value)
                                }
                                value={postCapacidad}
                                disabled={loading}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label>Fecha Instalación</label>
                              <Input
                                type="date"
                                onChange={(e) =>
                                  setPostInstalacion(e.target.value)
                                }
                                value={postInstalacion}
                                disabled={loading}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label>Fecha Fabricación</label>
                              <Input
                                type="date"
                                onChange={(e) =>
                                  setPostFechaFabricacion(e.target.value)
                                }
                                value={postFechaFabricacion}
                                disabled={loading}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label>Fecha Próxima Prueba</label>
                              <Input
                                type="date"
                                onChange={(e) => setPostPrueba(e.target.value)}
                                value={postPrueba}
                                disabled={loading}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label>Fecha Última Prueba</label>
                              <Input
                                type="date"
                                onChange={(e) =>
                                  setPostUltimaPrueba(e.target.value)
                                }
                                value={postUltimaPrueba}
                                disabled={loading}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    )}

                    <button
                      className="btn btn-info btn-lg"
                      onClick={postData}
                      disabled={loading}
                    >
                      {loading ? "Guardando..." : "Agregar"}
                    </button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <hr />
        <ObtenerEquiposInstalados OrdenId={props.idOrden} />
      </ReactModal>
    </>
  );
};

export default AsignaEquiposEdicion;
